import { Link } from "react-router-dom";
import LogoIcon from "../../icons/Logo";
import StagingLogoIcon from "../../icons/StagingLogo";

export default function LogoLink() {
  return <Link to="/">{isStaging ? <StagingLogoIcon /> : <LogoIcon />}</Link>;
}

const isStaging = Boolean(process.env.REACT_APP_IS_STAGING);
